import style from "./Flex.module.css";
import clsx from "classnames";
import { cloneElement, Children } from "react";
import React from "react";

function VerticalFlex(props) {
  const childrenWithProps = Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      // if(child.type.name){
      return React.cloneElement(child, {
        parentClass: "vertical",
        flexStart: props.flexStart ? props.flexStart : null,
      });
      // }
    }
    // return child;
  });

  return (
    <div
      ref={props.Ref}
      className={clsx(style.flex, style.vertical)}
      style={{
        width: props.width ? props.width : null,
        height: props.height ? props.height : null,
        maxHeight: props.maxHeight ? props.maxHeight : null,
        minHeight: props.minHeight ? props.minHeight : null,
        overflow: props.overflow ? props.overflow : null,
        overflowX: props.overflowX ? props.overflowX : props.overflow,
        overflowY: props.overflowY ? props.overflowY : props.overflow,
        gap: props.gap ? props.gap : null,
        alignItems: props.alignItems
          ? props.alignItems
          : props.flexStart
          ? "flex-start"
          : "center",
        backgroundColor: props.backgroundColor
          ? props.backgroundColor
          : "transparent",
        padding: props.padding ? props.padding : null,
        paddingLeft: props.paddingLeft ? props.paddingLeft : null,
        paddingRight: props.paddingRight ? props.paddingRight : null,
        paddingTop: props.paddingTop ? props.paddingTop : null,
        paddingBottom: props.paddingBottom ? props.paddingBottom : null,
        marginTop: props.marginTop ? props.marginTop : null,
        justifyContent: props.justifyContent ? props.justifyContent : null,
        borderRadius: props.borderRadius ? props.borderRadius : null,
        margin: props.margin ? props.margin : null,
        flexDirection: props.direction ? props.direction : "column",
        border: props.border ? props.border : null,
        borderRight: props.borderRight ? props.borderRight : null,
        borderLeft: props.borderLeft ? props.borderLeft : null,
        borderTop: props.borderTop ? props.borderTop : null,
        borderBottom: props.borderBottom ? props.borderBottom : null,
        flexBasis: props.flexBasis ? props.flexBasis : null,
        flexGrow: props.flexGrow ? props.flexGrow : null,
        maxWidth: props.maxWidth ? props.maxWidth : null,
        scrollbarWidth: props.hideScrollbar ? "none" : null,
        msOverflowStyle: props.hideScrollbar ? "none" : null,
      }}
    >
      {childrenWithProps}
    </div>
  );
}

export default VerticalFlex;
